import { getDashboardURL } from '@/inc/url/site'
import { IframeModalLink } from '@/components/IframeModal'

export const PostEditLink = ({
  post,
  label,
  className,
}: {
  post: {
    id: string
    title: string
    url: string
    created_by: string
    created_as?: string
  }
  label?: string
  className?: string
}) =>
  post.created_as === 'topic' ? (
    <IframeModalLink
      href={getDashboardURL(
        `/posts/${post.id}/edit?next=${encodeURIComponent(post.url)}`
      )}
      src={getDashboardURL(
        `/posts/${post.id}/edit?next=${encodeURIComponent(post.url)}&modal=true`
      )}
      label={label ?? 'Edit post details'}
      onCompleted={`/posts/${post.id}`}
      className={className}
    />
  ) : post.created_as === 'rich-post' ? (
    <a
      href={getDashboardURL(
        `/cases/${post.id}/edit?next=${encodeURIComponent(post.url)}`
      )}
      target="_blank"
      className={className}
    >
      {label ?? 'Edit post details'}
    </a>
  ) : (
    <a href={`/cases/${post.id}/edit`} className={className}>
      {label ??
        (post.created_as === 'poll'
          ? 'Edit poll details'
          : 'Edit post details')}
    </a>
  )
